import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CustomerModel } from '../../models/customer.model';
import { CustomerService } from '../../services/customer.service';
import { Router } from '@angular/router';
import { ServService } from '../../services/serv.service';
import { SmsService } from '../../services/sms.service';
import { LetterService } from '../../services/letter.service';
import { OrderService } from '../../services/order.service';

@Component({
    selector   : 'my-customer',
    template: require('./customer.component.html'),
    styles: [require('./customer.component.scss')]
})
export class CustomerComponent implements OnInit {

    customer: CustomerModel;

    buttons: any;
    showComment:boolean = false;

    tabs: any = [
        {'title': 'Résumé', 'component': 'summary'},
        {'title': 'Études Posturales', 'component': 'table', 'functionLoader': 'getPosturals'},
        {'title': 'Vélos', 'component': 'table', 'functionLoader': 'getBikes'},
        {'title': 'Documents', 'component': 'table', 'functionLoader': 'getDocuments'},
        {'title': 'Activités', 'component': 'table', 'functionLoader': 'getActivities'}
    ];

    listModal: any = {
        'delete' : false,
        'archive': false,
        'unarchive': false
    };

    constructor(public orderService:OrderService, public customerService: CustomerService, private route: ActivatedRoute, private router: Router, public servService:ServService, private smsService: SmsService, private letterService:LetterService) {
        this.customer = new CustomerModel(customerService);
        this.buttons  = {
            'left'  : [
                {'title': 'sms', 'style': 'primary', 'action': 'sendSMS', 'model': this, 'icon': 'fa-comment-o'},
                {'title': 'courrier', 'style': 'primary', 'action': 'sendLetter', 'model': this, 'icon': 'fa-envelope-o'}
                ],
            'center': [
                {'title': 'facture', 'style': 'primary', 'action': 'newInvoice', 'model': this, 'icon': 'fa-money'},
                {'title': 'réparation', 'style': 'primary', 'action': 'fite', 'model': this, 'icon': 'fa-bicycle'},
                {'title': 'commande', 'style': 'primary', 'action': 'order', 'model': this, 'icon': 'fa-briefcase'},
                {'title': 'devis', 'style': 'primary', 'action': 'newQuote', 'model': this, 'icon': 'fa-money'},
            ],
            'right' : [
                {
                    'title' : 'archiver',
                    'style' : 'secondary',
                    'action': 'openArchive',
                    'model' : this,
                    'icon'  : 'fa-file-archive-o'
                },
                // {'title': 'supprimer', 'style': 'secondary', 'action': 'openDelete', 'model': this, 'icon': 'fa-trash'},
            ],
        };
    }

    ngOnInit() {
        this.showComment = false;
        this.route.params.subscribe(params=> {
            //dans le cas du clique sur le bouton via la recherche
            if (params['data']) {
                this.customer = new CustomerModel(this.customerService);
                this.insertName(params['data']);
            } else if (params['privateId'] !== undefined) {

                this.customer.privateId = params['privateId'];
                this.customerService.load(params['privateId'], this.customer);
                //ce trick permet de reloader les onglets, car le dom changera et bingo refresh !
                this.customerService.tabActive = 'Résumé';
                this.tabs = [
                    {'title': 'Résumé', 'component': 'summary'},
                    {'title': 'Études Posturales', 'component': 'table', 'functionLoader': 'getPosturals'},
                    {'title': 'Vélos', 'component': 'table', 'functionLoader': 'getBikes'},
                    {'title': 'Documents', 'component': 'table', 'functionLoader': 'getDocuments'},
                    {'title': 'Activités', 'component': 'table', 'functionLoader': 'getActivities'}
                ];
            }
        });
    }

    looser() {
        this.customer.looser = !this.customer.looser;
        this.customerService.update(this.customer, 'looser');
    }

    openDelete() {
        this.listModal['delete'] = true;
    }

    openArchive() {
        if (this.customer.archive)
            this.listModal['unarchive'] = true;
        else
            this.listModal['archive'] = true;
    }

    newInvoice() {
        this.router.navigate(['/invoice/' + this.customer.privateId]);
    }

    newQuote() {
        console.log('navigating to /quote');
        this.router.navigate(['/quote/' + this.customer.privateId]);
    }

    insertName(data) {
        data                    = data.substr(4) + ' ';
        this.customer.lastName  = data.substr(0, data.indexOf(' '));
        this.customer.firstName = data.substr(data.indexOf(' ') + 1);
    }

    sendSMS(){
        this.smsService.open(this.customer.privateId, this.customer.phoneMobile, this.customer.lastName + ' ' + this.customer.firstName);
    }

    sendLetter(){
        this.letterService.open(this.customer);
    }

    fite(){
        this.servService.create(this.customer.privateId);
    }

    order(){
        this.orderService.create(this.customer.privateId);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/pages/customer/customer.component.ts